import SummaryCards from './SummaryCards';
import RevenueReport from  './RevenueReport';
import RevenueAndPayment from './RevenueAndPayment';
import BillingChart from './BillingChart'

function Main() {
  return (
    <div className="App">
       <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <SummaryCards />
            </div>


           <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
                  <RevenueReport />

           </div>  
        <RevenueAndPayment />
    <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
            <BillingChart />

   </div> 
    </div>
  );
}

export default Main;
